module.exports = __webpack_public_path__ + "img/single_bidding_detail.446be734.png";